import { FC } from 'react';
import colors from 'styles/_colors.module.scss';

const AboutActive: FC = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="80"
    height="80"
    fill="none"
    viewBox="0 0 80 80"
  >
    <path
      fill={colors['--green-500']}
      d="M57.333 22.602a1.5 1.5 0 100-3v3zM67.5 33.858a1.5 1.5 0 00-3 0h3zm-15.594-7.034h-1.5a1.5 1.5 0 002.493 1.124l-.993-1.124zm6.128-5.412l.993 1.125a1.5 1.5 0 000-2.249l-.993 1.124zM51.906 16l.994-1.124A1.5 1.5 0 0050.406 16h1.5zM41.5 32.583a1.5 1.5 0 10-3 0h3zm-3 21.685a1.5 1.5 0 103 0h-3zm14.555-12.756a1.5 1.5 0 10-3 0h3zm-3 12.756a1.5 1.5 0 003 0h-3zm-20.11-12.756a1.5 1.5 0 10-3 0h3zm-3 12.756a1.5 1.5 0 003 0h-3zm30.388-34.666h-39v3h39v-3zm-39 0c-1.49 0-2.952.522-4.057 1.497l1.986 2.248c.521-.46 1.264-.745 2.071-.745v-3zM14.276 21.1c-1.11.98-1.776 2.353-1.776 3.83h3c0-.552.247-1.127.762-1.581l-1.986-2.25zm-1.776 3.83v35.717h3V24.93h-3zm0 35.717c0 1.477.666 2.85 1.776 3.83l1.986-2.248c-.515-.455-.762-1.029-.762-1.582h-3zm1.776 3.83c1.104.976 2.566 1.497 4.057 1.497v-3c-.807 0-1.55-.285-2.07-.745l-1.987 2.249zm4.057 1.497h43.334v-3H18.333v3zm43.334 0c1.49 0 2.953-.521 4.057-1.496l-1.986-2.249c-.521.46-1.264.745-2.071.745v3zm4.057-1.496c1.11-.98 1.776-2.354 1.776-3.83h-3c0 .552-.247 1.126-.762 1.581l1.986 2.249zm1.776-3.83V33.857h-3v26.788h3zm-14.6-32.7l6.127-5.41-1.986-2.249-6.127 5.411 1.985 2.249zm6.127-7.659L52.9 14.876l-1.987 2.248 6.128 5.413 1.986-2.249zM50.407 16v10.824h3V16h-3zM38.5 32.583v21.685h3V32.583h-3zm11.555 8.93v12.755h3V41.512h-3zm-23.11 0v12.755h3V41.512h-3z"
    />
    <path stroke={colors['--green-500']} strokeWidth="3" d="M1.5 1.5H78.5V78.5H1.5z" />
  </svg>
);

export default AboutActive;
